import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CheckboxControl } from 'src/app/form-controls/checkbox/checkbox.control';
import { SelectControl, SelectItem } from 'src/app/form-controls/select/select.control';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { RespiratoryEffort, RespiratoryRateActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionAlertComponent } from '../../action-alert/action-alert.component';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface RespiratoryRateActionFormGroup {
	breathsPerMinute: FormControl<UnitQuantity | null>;
	panting: FormControl<boolean | null>;
	effort: FormControl<RespiratoryEffort | null>;
}

@Component({
    selector: 'app-respiratory-rate-and-effort-action-controls-v2',
    templateUrl: './respiratory-rate-and-effort-action-controls-v2.component.html',
    styleUrls: ['../../../common.scss', './respiratory-rate-and-effort-action-controls-v2.component.scss'],
    imports: [ReactiveFormsModule, SelectControl, CommonActionControlsComponent, ActionFormComponent, CheckboxControl, ActionAlertComponent, UnitQuantityControl],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RespiratoryRateActionControlsComponentV2 implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: RespiratoryRateActionV2;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as RespiratoryRateActionV2;
	}

	@Input() form!: FormGroup<RespiratoryRateActionFormGroup>;
	@Input() item!: Row | null;
	

	heartRhythmItems: SelectItem[] = [
		{ text: 'Normal', value: RespiratoryEffort.Normal },
		{ text: 'Abnormal', value: RespiratoryEffort.Abnormal }
	];

	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('breathsPerMinute', this.formBuilder.control(this.action?.breathsPerMinute ?? null));
		this.form.addControl('panting', this.formBuilder.control(this.action?.panting ?? null));
		this.form.addControl('effort', this.formBuilder.control(this.action?.effort ?? null));
	}
}